import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import { deletePaymentGateway } from '../../services'

interface UseMutationDeletePaymentGatewayProps {
	id: string
}

export default function useMutationDeletePaymentGateway(
	props?: UseBaseMutationOptions<void, UseMutationDeletePaymentGatewayProps>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.DeletePaymentGateway],
		mutationFn: ({ id }) => deletePaymentGateway(id),
		...props,
	})
}
